/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
    ScreenerBedUnitToJSONTyped,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface BulkUpdateScreenerBedUnitsRequest
 */
export interface BulkUpdateScreenerBedUnitsRequest {
    /**
     * 
     */
    units: Array<ScreenerBedUnit>;
}

/**
 * Check if a given object implements the BulkUpdateScreenerBedUnitsRequest interface.
 */
export function instanceOfBulkUpdateScreenerBedUnitsRequest(value: object): value is BulkUpdateScreenerBedUnitsRequest {
    if (!('units' in value) || value['units'] === undefined) return false;
    return true;
}

export function BulkUpdateScreenerBedUnitsRequestFromJSON(json: any): BulkUpdateScreenerBedUnitsRequest {
    return BulkUpdateScreenerBedUnitsRequestFromJSONTyped(json, false);
}

export function BulkUpdateScreenerBedUnitsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateScreenerBedUnitsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'units': ((json['units'] as Array<any>).map(ScreenerBedUnitFromJSON)),
    };
}

export function BulkUpdateScreenerBedUnitsRequestToJSON(json: any): BulkUpdateScreenerBedUnitsRequest {
    return BulkUpdateScreenerBedUnitsRequestToJSONTyped(json, false);
}

export function BulkUpdateScreenerBedUnitsRequestToJSONTyped(value?: BulkUpdateScreenerBedUnitsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'units': ((value['units'] as Array<any>).map(ScreenerBedUnitToJSON)),
    };
}

